import React from 'react';
import { Link } from 'react-router-dom';

const PageHeader = ({ title, subtitle, buttonText, buttonTo, onButtonClick, actions }) => {
  return (
    <div className="page-header">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <h1 className="page-title">{title}</h1>
          {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>
        {/* Support custom actions prop */}
        {actions && actions}
        {/* Backward compatibility with existing props */}
        {!actions && buttonText && buttonTo && !onButtonClick && (
          <Link to={buttonTo} className="add-chauffeur-btn">
            <i className="bi bi-plus-circle me-2"></i>
            {buttonText}
          </Link>
        )}
        {!actions && buttonText && onButtonClick && (
          <button type="button" className="add-chauffeur-btn" onClick={onButtonClick}>
            <i className="bi bi-plus-circle me-2"></i>
            {buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default PageHeader; 